import { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_915c8ab5-c9f9-4fcf-8c0b-1e6d3032545f/artifacts/vvsjzypx_logo%202_strade%20sicure_2026.jpg";

// Language Context
const LanguageContext = createContext();

const useLanguage = () => useContext(LanguageContext);

// Translations
const translations = {
  it: {
    // Navigation
    home: "Home",
    aboutUs: "Chi Siamo",
    campaigns: "Campagne",
    contact: "Contatti",
    support: "Sostienici",
    
    // Hero
    heroTitle: "Insieme per Strade più Sicure",
    heroSubtitle: "Promuoviamo la sicurezza stradale attraverso campagne di sensibilizzazione e prevenzione degli incidenti",
    discoverCampaigns: "Scopri le Campagne",
    supportUs: "Sostienici",
    
    // Features
    prevention: "Prevenzione",
    ourMission: "La nostra missione",
    community: "Comunità",
    togetherStronger: "Insieme siamo più forti",
    awareness: "Sensibilizzazione",
    educateToSave: "Educare per salvare vite",
    safety: "Sicurezza",
    saferRoads: "Strade più sicure per tutti",
    
    // About
    aboutTitle: "Chi Siamo",
    aboutSubtitle: "Associazione di Promozione Sociale per la Sicurezza Stradale",
    ourMissionTitle: "La Nostra Missione",
    ourMissionText: "Associazione Strade Sicure APS è un'associazione di promozione sociale dedicata alla sicurezza stradale. Ci impegniamo quotidianamente nella promozione delle migliori pratiche di prevenzione contro gli incidenti stradali attraverso campagne di sensibilizzazione mirate ed efficaci.",
    ourVisionTitle: "La Nostra Visione",
    ourVisionText: "Crediamo in un futuro dove le strade siano luoghi sicuri per tutti: guidatori, pedoni e ciclisti. Attraverso l'educazione, la consapevolezza e l'azione collettiva, lavoriamo per ridurre drasticamente gli incidenti stradali nella nostra comunità e oltre.",
    ourValuesTitle: "I Nostri Valori",
    ourValuesText: "Responsabilità, prevenzione, solidarietà e trasparenza guidano ogni nostra azione. Collaboriamo con istituzioni, scuole e cittadini per creare una cultura della sicurezza stradale basata sul rispetto reciproco e la consapevolezza dei rischi.",
    associationInfo: "Informazioni Associazione",
    denomination: "Denominazione",
    fiscalCode: "Codice Fiscale",
    legalSeat: "Sede Legale",
    
    // Campaigns
    campaignsTitle: "Le Nostre Campagne",
    campaignsSubtitle: "Iniziative di sensibilizzazione per la prevenzione degli incidenti stradali",
    responsibleDriving: "Guida Responsabile",
    responsibleDrivingDesc: "Campagna di sensibilizzazione contro la guida in stato di ebbrezza e sotto effetto di sostanze stupefacenti. Promuoviamo comportamenti responsabili per salvare vite.",
    schoolMeetings: "Incontri nelle scuole",
    infoEvents: "Eventi informativi",
    eduMaterial: "Distribuzione materiale educativo",
    stopPhone: "Stop al Cellulare",
    stopPhoneDesc: "Campagna contro l'uso dello smartphone alla guida. La distrazione è una delle principali cause di incidenti: sensibilizziamo i guidatori sui pericoli.",
    workshops: "Workshop educativi",
    socialCampaigns: "Campagne social media",
    policeCollab: "Collaborazione con le forze dell'ordine",
    safeSpeed: "Velocità Sicura",
    safeSpeedDesc: "Promuoviamo il rispetto dei limiti di velocità e la guida prudente. Una velocità adeguata può fare la differenza tra la vita e la morte.",
    riskMonitoring: "Monitoraggio zone ad alto rischio",
    infoCampaigns: "Campagne di informazione",
    localCollab: "Collaborazione con enti locali",
    safeChildren: "Bambini Sicuri",
    safeChildrenDesc: "Campagna dedicata alla sicurezza dei più piccoli: uso corretto di seggiolini auto, educazione stradale nelle scuole e protezione dei pedoni più vulnerabili.",
    parentCourses: "Corsi per genitori",
    schoolEducation: "Educazione stradale nelle scuole",
    seatChecks: "Controlli sicurezza seggiolini",
    protectedCyclists: "Ciclisti Protetti",
    protectedCyclistsDesc: "Promuoviamo la convivenza sicura tra automobilisti e ciclisti attraverso la sensibilizzazione sul rispetto delle distanze di sicurezza e visibilità.",
    coexistenceCampaigns: "Campagne di convivenza stradale",
    safetyAccessories: "Distribuzione accessori sicurezza",
    bikeLanes: "Promozione piste ciclabili",
    safePedestrians: "Pedoni al Sicuro",
    safePedestriansDesc: "Campagna per la protezione dei pedoni con focus su attraversamenti pedonali sicuri, illuminazione adeguata e rispetto della precedenza.",
    infraImprovement: "Miglioramento infrastrutture",
    driverAwareness: "Sensibilizzazione guidatori",
    safeBehavior: "Educazione comportamenti sicuri",
    
    // Contact
    contactTitle: "Contattaci",
    contactSubtitle: "Siamo qui per rispondere alle tue domande e supportare le tue iniziative",
    contactInfo: "Informazioni di Contatto",
    seat: "Sede",
    phone: "Telefono",
    email: "Email",
    sendMessage: "Inviaci un Messaggio",
    fullName: "Nome e Cognome",
    subject: "Oggetto",
    message: "Messaggio",
    sendBtn: "Invia Messaggio",
    sending: "Invio in corso...",
    messageSent: "Messaggio inviato con successo! Ti risponderemo al più presto.",
    
    // Donations
    donationsTitle: "Sostienici",
    donationsSubtitle: "Il tuo contributo aiuta a salvare vite sulla strada",
    whyDonate: "Perché Donare?",
    donationsAllow: "Le tue donazioni ci permettono di:",
    benefit1: "Organizzare campagne di sensibilizzazione nelle scuole e nella comunità",
    benefit2: "Produrre materiale educativo e informativo sulla sicurezza stradale",
    benefit3: "Collaborare con le istituzioni per migliorare le infrastrutture stradali",
    benefit4: "Supportare le vittime di incidenti stradali e le loro famiglie",
    benefit5: "Realizzare eventi e workshop educativi gratuiti",
    benefit6: "Promuovere progetti di ricerca e prevenzione",
    everyDonation: "Ogni donazione, grande o piccola, fa la differenza!",
    contribute: "Contribuisci a costruire un futuro con strade più sicure per tutti.",
    bankTransfer: "Bonifico Bancario",
    payableTo: "Intestato a",
    copyIban: "Copia IBAN",
    ibanCopied: "IBAN copiato!",
    cardDonation: "Puoi Donare anche con Carte di Credito/Debito",
    donateCard: "Dona con Carta",
    contactUs: "Contattaci",
    otherDonationMethods: "Per informazioni su altre modalità di donazione:",
    taxBenefits: "Benefici Fiscali",
    taxBenefitsText: "Le donazioni alle APS sono deducibili/detraibili fiscalmente secondo le normative vigenti. Richiedi la ricevuta per il tuo contributo.",
    
    // Footer
    quickLinks: "Link Rapidi",
    allRightsReserved: "Tutti i diritti riservati.",
  },
  en: {
    // Navigation
    home: "Home",
    aboutUs: "About Us",
    campaigns: "Campaigns",
    contact: "Contact",
    support: "Support Us",
    
    // Hero
    heroTitle: "Together for Safer Roads",
    heroSubtitle: "We promote road safety through awareness campaigns and accident prevention",
    discoverCampaigns: "Discover Campaigns",
    supportUs: "Support Us",
    
    // Features
    prevention: "Prevention",
    ourMission: "Our mission",
    community: "Community",
    togetherStronger: "Together we are stronger",
    awareness: "Awareness",
    educateToSave: "Educate to save lives",
    safety: "Safety",
    saferRoads: "Safer roads for everyone",
    
    // About
    aboutTitle: "About Us",
    aboutSubtitle: "Social Promotion Association for Road Safety",
    ourMissionTitle: "Our Mission",
    ourMissionText: "Associazione Strade Sicure APS is a social promotion association dedicated to road safety. We are committed daily to promoting best practices for accident prevention through targeted and effective awareness campaigns.",
    ourVisionTitle: "Our Vision",
    ourVisionText: "We believe in a future where roads are safe places for everyone: drivers, pedestrians, and cyclists. Through education, awareness, and collective action, we work to drastically reduce road accidents in our community and beyond.",
    ourValuesTitle: "Our Values",
    ourValuesText: "Responsibility, prevention, solidarity, and transparency guide every action we take. We collaborate with institutions, schools, and citizens to create a road safety culture based on mutual respect and risk awareness.",
    associationInfo: "Association Information",
    denomination: "Name",
    fiscalCode: "Tax Code",
    legalSeat: "Legal Address",
    
    // Campaigns
    campaignsTitle: "Our Campaigns",
    campaignsSubtitle: "Awareness initiatives for road accident prevention",
    responsibleDriving: "Responsible Driving",
    responsibleDrivingDesc: "Awareness campaign against drunk driving and driving under the influence of drugs. We promote responsible behavior to save lives.",
    schoolMeetings: "School meetings",
    infoEvents: "Information events",
    eduMaterial: "Educational material distribution",
    stopPhone: "Stop Phone Use",
    stopPhoneDesc: "Campaign against smartphone use while driving. Distraction is one of the main causes of accidents: we raise driver awareness about the dangers.",
    workshops: "Educational workshops",
    socialCampaigns: "Social media campaigns",
    policeCollab: "Collaboration with law enforcement",
    safeSpeed: "Safe Speed",
    safeSpeedDesc: "We promote respect for speed limits and prudent driving. Adequate speed can make the difference between life and death.",
    riskMonitoring: "High-risk zone monitoring",
    infoCampaigns: "Information campaigns",
    localCollab: "Collaboration with local authorities",
    safeChildren: "Safe Children",
    safeChildrenDesc: "Campaign dedicated to children's safety: correct use of car seats, road education in schools, and protection of the most vulnerable pedestrians.",
    parentCourses: "Courses for parents",
    schoolEducation: "Road education in schools",
    seatChecks: "Car seat safety checks",
    protectedCyclists: "Protected Cyclists",
    protectedCyclistsDesc: "We promote safe coexistence between motorists and cyclists through awareness about respecting safety distances and visibility.",
    coexistenceCampaigns: "Road coexistence campaigns",
    safetyAccessories: "Safety accessories distribution",
    bikeLanes: "Bike lane promotion",
    safePedestrians: "Safe Pedestrians",
    safePedestriansDesc: "Campaign for pedestrian protection focusing on safe crosswalks, adequate lighting, and right-of-way respect.",
    infraImprovement: "Infrastructure improvement",
    driverAwareness: "Driver awareness",
    safeBehavior: "Safe behavior education",
    
    // Contact
    contactTitle: "Contact Us",
    contactSubtitle: "We're here to answer your questions and support your initiatives",
    contactInfo: "Contact Information",
    seat: "Address",
    phone: "Phone",
    email: "Email",
    sendMessage: "Send Us a Message",
    fullName: "Full Name",
    subject: "Subject",
    message: "Message",
    sendBtn: "Send Message",
    sending: "Sending...",
    messageSent: "Message sent successfully! We'll respond as soon as possible.",
    
    // Donations
    donationsTitle: "Support Us",
    donationsSubtitle: "Your contribution helps save lives on the road",
    whyDonate: "Why Donate?",
    donationsAllow: "Your donations allow us to:",
    benefit1: "Organize awareness campaigns in schools and the community",
    benefit2: "Produce educational and informational material on road safety",
    benefit3: "Collaborate with institutions to improve road infrastructure",
    benefit4: "Support road accident victims and their families",
    benefit5: "Organize free educational events and workshops",
    benefit6: "Promote research and prevention projects",
    everyDonation: "Every donation, big or small, makes a difference!",
    contribute: "Contribute to building a future with safer roads for everyone.",
    bankTransfer: "Bank Transfer",
    payableTo: "Payable to",
    copyIban: "Copy IBAN",
    ibanCopied: "IBAN copied!",
    cardDonation: "You can also donate with Credit/Debit Cards",
    donateCard: "Donate by Card",
    contactUs: "Contact Us",
    otherDonationMethods: "For information on other donation methods:",
    taxBenefits: "Tax Benefits",
    taxBenefitsText: "Donations to APS are tax deductible/deductible according to current regulations. Request a receipt for your contribution.",
    
    // Footer
    quickLinks: "Quick Links",
    allRightsReserved: "All rights reserved.",
  }
};

// Flag Components
const ItalianFlag = () => (
  <svg className="w-6 h-4 rounded-sm shadow-sm" viewBox="0 0 36 24">
    <rect width="12" height="24" fill="#009246"/>
    <rect x="12" width="12" height="24" fill="#fff"/>
    <rect x="24" width="12" height="24" fill="#ce2b37"/>
  </svg>
);

const EnglishFlag = () => (
  <svg className="w-6 h-4 rounded-sm shadow-sm" viewBox="0 0 36 24">
    <rect width="36" height="24" fill="#012169"/>
    <path d="M0,0 L36,24 M36,0 L0,24" stroke="#fff" strokeWidth="4"/>
    <path d="M0,0 L36,24 M36,0 L0,24" stroke="#C8102E" strokeWidth="2.5"/>
    <path d="M18,0 V24 M0,12 H36" stroke="#fff" strokeWidth="6"/>
    <path d="M18,0 V24 M0,12 H36" stroke="#C8102E" strokeWidth="4"/>
  </svg>
);

// Icons components
const ShieldIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
  </svg>
);

const UsersIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
  </svg>
);

const MegaphoneIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
  </svg>
);

const LockIcon = () => (
  <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);

const MailIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const LocationIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const CheckIcon = () => (
  <svg className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
);

const MenuIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

const CloseIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const CopyIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
  </svg>
);

// Language Selector Component
const LanguageSelector = ({ scrolled }) => {
  const { language, setLanguage } = useLanguage();
  
  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => setLanguage('it')}
        className={`p-1 rounded transition-all ${language === 'it' ? 'ring-2 ring-green-500 scale-110' : 'opacity-70 hover:opacity-100'}`}
        title="Italiano"
      >
        <ItalianFlag />
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`p-1 rounded transition-all ${language === 'en' ? 'ring-2 ring-green-500 scale-110' : 'opacity-70 hover:opacity-100'}`}
        title="English"
      >
        <EnglishFlag />
      </button>
    </div>
  );
};

// Navigation Component
const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: "#home", label: t.home },
    { href: "#chi-siamo", label: t.aboutUs },
    { href: "#campagne", label: t.campaigns },
    { href: "#contatti", label: t.contact },
    { href: "#donazioni", label: t.support },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <a href="#home" className="flex items-center space-x-3">
            <img src={LOGO_URL} alt="Logo Strade Sicure" className="h-16 w-auto" />
          </a>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            {/* Language Flags */}
            <LanguageSelector scrolled={scrolled} />
            
            {/* Separator */}
            <div className={`h-6 w-px ${scrolled ? 'bg-gray-300' : 'bg-white/30'}`}></div>
            
            {/* Nav Links */}
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`font-medium transition-colors ${scrolled ? 'text-gray-700 hover:text-green-600' : 'text-white hover:text-green-300'}`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center space-x-3">
            <LanguageSelector scrolled={scrolled} />
            <button
              className="p-2"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden bg-white rounded-lg shadow-lg mt-2 py-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="block px-4 py-3 text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors"
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

// Hero Section
const HeroSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-green-900 to-gray-900">
      <div className="absolute inset-0 bg-black/40"></div>
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNCI+PHBhdGggZD0iTTM2IDM0djItSDI0di0yaDEyek0zNiAyOHYySDI0di0yaDEyeiIvPjwvZz48L2c+PC9zdmc+')] opacity-30"></div>
      
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto">
        <div className="mb-8 flex justify-center">
          <img 
            src={LOGO_URL} 
            alt="Logo Associazione Strade Sicure APS" 
            className="h-40 md:h-52 w-auto drop-shadow-2xl bg-white/90 rounded-2xl p-4"
          />
        </div>
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
          {t.heroTitle}
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 mb-10 max-w-3xl mx-auto">
          {t.heroSubtitle}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#campagne"
            className="px-8 py-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-full transition-all transform hover:scale-105 shadow-lg"
          >
            {t.discoverCampaigns}
          </a>
          <a
            href="#donazioni"
            className="px-8 py-4 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-semibold rounded-full border-2 border-white/50 transition-all"
          >
            {t.supportUs}
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg className="w-8 h-8 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </section>
  );
};

// Features Section
const FeaturesSection = () => {
  const { t } = useLanguage();
  
  const features = [
    { icon: <ShieldIcon />, title: t.prevention, subtitle: t.ourMission },
    { icon: <UsersIcon />, title: t.community, subtitle: t.togetherStronger },
    { icon: <MegaphoneIcon />, title: t.awareness, subtitle: t.educateToSave },
    { icon: <LockIcon />, title: t.safety, subtitle: t.saferRoads },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-xl hover:bg-green-50 transition-colors">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 text-green-600 rounded-full mb-4">
                {feature.icon}
              </div>
              <h3 className="font-bold text-gray-900 mb-1">{feature.title}</h3>
              <p className="text-sm text-gray-600">{feature.subtitle}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="chi-siamo" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.aboutTitle}</h2>
          <p className="text-xl text-gray-600">{t.aboutSubtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <h3 className="text-2xl font-bold text-green-700 mb-4">{t.ourMissionTitle}</h3>
            <p className="text-gray-600 leading-relaxed">{t.ourMissionText}</p>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <h3 className="text-2xl font-bold text-green-700 mb-4">{t.ourVisionTitle}</h3>
            <p className="text-gray-600 leading-relaxed">{t.ourVisionText}</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <h3 className="text-2xl font-bold text-green-700 mb-4">{t.ourValuesTitle}</h3>
            <p className="text-gray-600 leading-relaxed">{t.ourValuesText}</p>
          </div>
          
          <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-2xl p-8 text-white shadow-lg">
            <h3 className="text-2xl font-bold mb-4">{t.associationInfo}</h3>
            <div className="space-y-3">
              <p><span className="font-semibold">{t.denomination}:</span> Associazione Strade Sicure APS</p>
              <p><span className="font-semibold">{t.fiscalCode}:</span> 93066470910</p>
              <p><span className="font-semibold">{t.legalSeat}:</span> Viale Murichessa 94, Nuoro</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Campaigns Section
const CampaignsSection = () => {
  const { t } = useLanguage();
  
  const campaigns = [
    {
      title: t.responsibleDriving,
      description: t.responsibleDrivingDesc,
      items: [t.schoolMeetings, t.infoEvents, t.eduMaterial],
      color: "from-red-500 to-red-600",
      icon: "🚗"
    },
    {
      title: t.stopPhone,
      description: t.stopPhoneDesc,
      items: [t.workshops, t.socialCampaigns, t.policeCollab],
      color: "from-blue-500 to-blue-600",
      icon: "📵"
    },
    {
      title: t.safeSpeed,
      description: t.safeSpeedDesc,
      items: [t.riskMonitoring, t.infoCampaigns, t.localCollab],
      color: "from-orange-500 to-orange-600",
      icon: "⚡"
    },
    {
      title: t.safeChildren,
      description: t.safeChildrenDesc,
      items: [t.parentCourses, t.schoolEducation, t.seatChecks],
      color: "from-yellow-500 to-yellow-600",
      icon: "👶"
    },
    {
      title: t.protectedCyclists,
      description: t.protectedCyclistsDesc,
      items: [t.coexistenceCampaigns, t.safetyAccessories, t.bikeLanes],
      color: "from-green-500 to-green-600",
      icon: "🚴"
    },
    {
      title: t.safePedestrians,
      description: t.safePedestriansDesc,
      items: [t.infraImprovement, t.driverAwareness, t.safeBehavior],
      color: "from-purple-500 to-purple-600",
      icon: "🚶"
    },
  ];

  return (
    <section id="campagne" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.campaignsTitle}</h2>
          <p className="text-xl text-gray-600">{t.campaignsSubtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {campaigns.map((campaign, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className={`bg-gradient-to-r ${campaign.color} p-6 text-white`}>
                <span className="text-4xl mb-4 block">{campaign.icon}</span>
                <h3 className="text-xl font-bold">{campaign.title}</h3>
              </div>
              <div className="p-6">
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">{campaign.description}</p>
                <ul className="space-y-2">
                  {campaign.items.map((item, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <CheckIcon />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Contact Section
const ContactSection = () => {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.post(`${API}/contact`, formData);
      if (response.data.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
        setTimeout(() => setSubmitted(false), 5000);
      }
    } catch (err) {
      console.error('Error sending message:', err);
      setError(err.response?.data?.detail || 'Errore nell\'invio del messaggio. Riprova più tardi.');
      setTimeout(() => setError(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contatti" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.contactTitle}</h2>
          <p className="text-xl text-gray-600">{t.contactSubtitle}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">{t.contactInfo}</h3>
            
            <div className="bg-white rounded-xl p-6 shadow-md flex items-start space-x-4">
              <div className="bg-green-100 p-3 rounded-full text-green-600">
                <LocationIcon />
              </div>
              <div>
                <h4 className="font-bold text-gray-900">{t.seat}</h4>
                <p className="text-gray-600">Viale Murichessa 94</p>
                <p className="text-gray-600">Nuoro, Sardegna</p>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md flex items-start space-x-4">
              <div className="bg-green-100 p-3 rounded-full text-green-600">
                <PhoneIcon />
              </div>
              <div>
                <h4 className="font-bold text-gray-900">{t.phone}</h4>
                <a href="tel:+393208083839" className="text-green-600 hover:text-green-700">+39 320 808 3839</a>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md flex items-start space-x-4">
              <div className="bg-green-100 p-3 rounded-full text-green-600">
                <MailIcon />
              </div>
              <div>
                <h4 className="font-bold text-gray-900">{t.email}</h4>
                <a href="mailto:info@associazionestradesicure.org" className="text-green-600 hover:text-green-700">info@associazionestradesicure.org</a>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">{t.sendMessage}</h3>
            
            {submitted && (
              <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-lg flex items-center">
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                {t.messageSent}
              </div>
            )}

            {error && (
              <div className="mb-6 p-4 bg-red-100 text-red-700 rounded-lg flex items-center">
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">{t.fullName} *</label>
                <input
                  type="text"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                />
              </div>
              
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t.email} *</label>
                  <input
                    type="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t.phone}</label>
                  <input
                    type="tel"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">{t.subject} *</label>
                <input
                  type="text"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all"
                  value={formData.subject}
                  onChange={(e) => setFormData({...formData, subject: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">{t.message} *</label>
                <textarea
                  required
                  rows={5}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all resize-none"
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className={`w-full py-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition-colors flex items-center justify-center ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}
              >
                {loading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {t.sending}
                  </>
                ) : (
                  t.sendBtn
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

// Donations Section
const DonationsSection = () => {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);
  const iban = "IE36 SUMU 9903 6512 5968 83";

  const copyIban = () => {
    navigator.clipboard.writeText(iban.replace(/\s/g, ''));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const benefits = [
    t.benefit1, t.benefit2, t.benefit3, t.benefit4, t.benefit5, t.benefit6
  ];

  return (
    <section id="donazioni" className="py-20 bg-gradient-to-br from-green-700 via-green-800 to-green-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">{t.donationsTitle}</h2>
          <p className="text-xl text-green-100">{t.donationsSubtitle}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Why Donate */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-6">{t.whyDonate}</h3>
            <p className="text-green-100 mb-6">{t.donationsAllow}</p>
            <ul className="space-y-4 mb-8">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-start text-white">
                  <svg className="w-5 h-5 text-green-300 mr-3 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  {benefit}
                </li>
              ))}
            </ul>
            <div className="bg-green-600/50 rounded-xl p-4">
              <p className="text-white font-semibold">{t.everyDonation}</p>
              <p className="text-green-100 text-sm mt-1">{t.contribute}</p>
            </div>
          </div>

          {/* How to Donate */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-4">{t.bankTransfer}</h3>
              <div className="space-y-3 text-gray-700">
                <p>{t.payableTo}: <span className="font-semibold">Associazione Strade Sicure APS</span></p>
                <p>CF: <span className="font-semibold">93066470910</span></p>
                <div className="bg-gray-100 rounded-lg p-4 mt-4">
                  <p className="text-sm text-gray-600 mb-2">IBAN:</p>
                  <div className="flex items-center justify-between">
                    <code className="text-lg font-mono font-bold text-green-700">{iban}</code>
                    <button
                      onClick={copyIban}
                      className="ml-4 p-2 bg-green-100 hover:bg-green-200 rounded-lg transition-colors"
                      title={t.copyIban}
                    >
                      {copied ? (
                        <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                      ) : (
                        <CopyIcon />
                      )}
                    </button>
                  </div>
                  {copied && <p className="text-sm text-green-600 mt-2">{t.ibanCopied}</p>}
                </div>
                
                {/* Link pagamento carta */}
                <div className="mt-6 pt-4 border-t border-gray-200">
                  <p className="text-gray-700 font-medium mb-3">{t.cardDonation}</p>
                  <a 
                    href="https://pay.sumup.com/b2c/QGWA510M" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold rounded-lg hover:from-green-700 hover:to-green-800 transition-all shadow-md hover:shadow-lg"
                  >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                    </svg>
                    {t.donateCard}
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-4">{t.contactUs}</h3>
              <p className="text-gray-600 mb-4">{t.otherDonationMethods}</p>
              <div className="space-y-3">
                <a href="tel:+393208083839" className="flex items-center text-green-600 hover:text-green-700">
                  <PhoneIcon />
                  <span className="ml-2">+39 320 808 3839</span>
                </a>
                <a href="mailto:info@associazionestradesicure.org" className="flex items-center text-green-600 hover:text-green-700">
                  <MailIcon />
                  <span className="ml-2">info@associazionestradesicure.org</span>
                </a>
              </div>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 rounded-r-xl p-6">
              <h4 className="font-bold text-yellow-800 mb-2">{t.taxBenefits}</h4>
              <p className="text-yellow-700 text-sm">{t.taxBenefitsText}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <img src={LOGO_URL} alt="Logo Strade Sicure" className="h-20 w-auto mb-4 bg-white/90 rounded-lg p-2" />
            <p className="text-gray-400 text-sm">{t.aboutSubtitle}</p>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">{t.quickLinks}</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#home" className="hover:text-green-400 transition-colors">{t.home}</a></li>
              <li><a href="#chi-siamo" className="hover:text-green-400 transition-colors">{t.aboutUs}</a></li>
              <li><a href="#campagne" className="hover:text-green-400 transition-colors">{t.campaigns}</a></li>
              <li><a href="#contatti" className="hover:text-green-400 transition-colors">{t.contact}</a></li>
              <li><a href="#donazioni" className="hover:text-green-400 transition-colors">{t.support}</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">{t.contact}</h4>
            <div className="space-y-2 text-gray-400 text-sm">
              <p>Viale Murichessa 94, Nuoro</p>
              <p>CF: 93066470910</p>
              <p><a href="tel:+393208083839" className="hover:text-green-400">+39 320 808 3839</a></p>
              <p><a href="mailto:info@associazionestradesicure.org" className="hover:text-green-400">info@associazionestradesicure.org</a></p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-500 text-sm">
          <p>&copy; {new Date().getFullYear()} Associazione Strade Sicure APS. {t.allRightsReserved}</p>
        </div>
      </div>
    </footer>
  );
};

// Logo fisso in basso a destra per coprire badge
const FixedLogo = () => (
  <div 
    className="fixed z-[99999] bg-white rounded-tl-2xl shadow-2xl flex items-center justify-center"
    style={{
      bottom: 0, 
      right: 0, 
      width: '200px', 
      height: '70px',
      padding: '12px 16px'
    }}
  >
    <img 
      src={LOGO_URL} 
      alt="Strade Sicure" 
      className="h-full w-auto object-contain"
    />
  </div>
);

// Main Home Page
const Home = () => {
  useEffect(() => {
    document.title = "Associazione Strade Sicure APS | Sicurezza Stradale";
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <HeroSection />
      <FeaturesSection />
      <AboutSection />
      <CampaignsSection />
      <ContactSection />
      <DonationsSection />
      <Footer />
      <FixedLogo />
    </div>
  );
};

// Language Provider Component
const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('it');
  const t = translations[language];
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
